var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"caption",attrs:{"color":_vm.color,"outlined":_vm.outlined,"dark":!_vm.outlined}},[_vm._v(" "+_vm._s(_vm.$te(_vm.options.label) ? _vm.$t(_vm.options.label) : _vm.$t('unknown'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }